import React from "react";
// import {
//   FaWater,
//   FaTshirt,
//   FaHeartbeat,
//   FaUtensils,
//   FaHome,
//   FaTools,
// } from "react-icons/fa";

import waterImg from "../../assets/images/service4.png";
import oxygenImg from "../../assets/images/service3.png";
import laundryImg from "../../assets/images/service5.png";
import tiffinImg from "../../assets/images/service6.png";
import homefoodImg from "../../assets/images/service1.png";
import repairImg from "../../assets/images/service2.png";

const services = [
  {
    title: "Water Supply & Accessories",
    description:
      "20/25 liter water Jar will now reach your doorstep. We also provide essential water related accessories so that there is never a shortage of water.",
    image: waterImg,
  },
  {
    title: "Oxygen Cylinders & Accessories",
    description:
      "Health comes first – that's why we deliver oxygen cylinders and essentials to your home with due care & responsibility.",
    image: oxygenImg,
  },
  {
    title: "Laundry Service",
    description:
      "Leave the hassle of washing and ironing to us. We collect your clothes, wash, iron and return them sparkling and fragrant.",
    image: laundryImg,
  },
  {
    title: "Tiffin Delivery Service",
    description:
      "Eat home-cooked food on a busy day at the office. We take tiffin from your home and deliver it to your office on time.",
    image: tiffinImg,
  },
];

const upcomingServices = [
  {
    title: "Home Food Delivery Service",
    description:
      "Want to taste home food but don’t have time to cook? Place an order from our app. We’ll prepare a specific quantity of healthy, fresh food as per your needs and deliver it.",
    image: homefoodImg,
  },
  {
    title: "Electrician & Plumber Service",
    description:
      "We solve all minor home repairs likes electrical problems or burst water pipe through our experienced staff.",
    image: repairImg,
  },
];

const ServiceCard = ({ icon, title, description, image }) => (
  <div className="flex flex-col items-center text-center bg-[#f7f0dade] rounded-xl shadow-lg p-6 w-full h-[420px]">
    <div className="w-full h-full flex items-center justify-center rounded-lg overflow-hidden mb-4">
      <img src={image} alt={title} className="h-full object-cover" />
    </div>
    <div className="flex items-center justify-center gap-2 mb-2">
      {icon}
      <h3 className="text-xl text-[#3d0000] font-bold">{title}</h3>
    </div>
    <p className="text-base text-black">{description}</p>
  </div>
);

export default function ServicesPage() {
  return (
    <div className="font-[Poppins] bg-gradient-to-r from-white to-blue-100 py-20 px-6 md:px-20 text-gray-800">

      {/* Our Services Section */}
      <h2 className="text-4xl font-bold text-center text-[#5e1136] mb-8">
        Our Services
      </h2>
      <p className="text-center text-lg text-black max-w-3xl mx-auto mb-24 mt-6 tracking-wide">
        Discover essential daily services designed to simplify your lifestyle — from water delivery to tiffin and laundry, everything you need is just a request away.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-24">
        {services.map((service, i) => (
          <ServiceCard key={i} {...service} />
        ))}
      </div>

      {/* Upcoming Services Section */}
      <h2 className="text-4xl font-bold text-center text-[#5e1136] mt-24 mb-8">
        Upcoming Services
      </h2>
      <p className="text-center text-lg text-black max-w-3xl mx-auto mb-24 mt-6 tracking-wide">
        We're constantly growing! Here’s a glimpse of services we’ll soon offer to make your home life even more convenient and hassle-free.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {upcomingServices.map((service, i) => (
          <ServiceCard key={i} {...service} />
        ))}
      </div>
    </div>
  );
}
